import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Related services")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Get Home Assistant account for Robonomics Parachain usage ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Recieve and decrypt the telemetry from your smart home IoT devices ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Set color for smart lamp via Robonomics Subscription - Decentrilized IoT cloud alternative. ")

export function render(_ctx, _cache) {
  const _component_robo_card_label_section = _resolveComponent("robo-card-label-section")
  const _component_robo_card_label = _resolveComponent("robo-card-label")
  const _component_robo_template_services_item = _resolveComponent("robo-template-services-item")
  const _component_robo_grid = _resolveComponent("robo-grid")
  const _component_robo_card_section = _resolveComponent("robo-card-section")
  const _component_robo_card = _resolveComponent("robo-card")
  const _component_robo_section = _resolveComponent("robo-section")

  return (_openBlock(), _createBlock(_component_robo_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_card_label_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_grid, {
                columnsRepeat: "3",
                offset: "x0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_robo_template_services_item, {
                    router: { name: 'home-assistant-account' },
                    label: "demo",
                    picture: "./images/services-ha.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "Home Assistant account"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    href: "https://vol4tim.github.io/account-manager/",
                    label: "demo",
                    picture: "./images/services-ha.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "SmartHome Telemetry"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    router: { name: 'lights-up' },
                    label: "demo",
                    picture: "./images/services-lights-up.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "Lights up!"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["providers"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}